import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "candlestick-chart" }
const _hoisted_2 = { class: "axis-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "threshold-line",
        style: {"left":"50%"}
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "threshold-line",
        style: {"left":"75%"}
      }, null, -1)),
      (_ctx.badLeft < _ctx.baselineLeft)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "range-line range-red",
            style: _normalizeStyle({ left: _ctx.badLeft + '%', width: (_ctx.baselineLeft - _ctx.badLeft) + '%' })
          }, null, 4))
        : (_ctx.badLeft > _ctx.baselineLeft)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "range-line range-red",
              style: _normalizeStyle({ left: _ctx.baselineLeft + '%', width: (_ctx.badLeft - _ctx.baselineLeft) + '%' })
            }, null, 4))
          : _createCommentVNode("", true),
      (_ctx.badLeft !== _ctx.baselineLeft)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "end-cap cap-red",
            style: _normalizeStyle({ left: _ctx.badLeft + '%' })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.goodLeft > _ctx.baselineLeft)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "range-line range-green",
            style: _normalizeStyle({ left: _ctx.baselineLeft + '%', width: (_ctx.goodLeft - _ctx.baselineLeft) + '%' })
          }, null, 4))
        : (_ctx.goodLeft < _ctx.baselineLeft)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "range-line range-green",
              style: _normalizeStyle({ left: _ctx.goodLeft + '%', width: (_ctx.baselineLeft - _ctx.goodLeft) + '%' })
            }, null, 4))
          : _createCommentVNode("", true),
      (_ctx.goodLeft !== _ctx.baselineLeft)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: "end-cap cap-green",
            style: _normalizeStyle({ left: _ctx.goodLeft + '%' })
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "baseline-dot",
        style: _normalizeStyle({ left: _ctx.baselineLeft + '%' })
      }, null, 4),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"tick-marks\" data-v-1fb2cb0a><span class=\"tick-label\" style=\"left:0%;\" data-v-1fb2cb0a>-1.0<br data-v-1fb2cb0a><span class=\"tick-sublabel\" data-v-1fb2cb0a>(Harmful)</span></span><span class=\"tick-label\" style=\"left:25%;\" data-v-1fb2cb0a>-0.5</span><span class=\"tick-label\" style=\"left:50%;\" data-v-1fb2cb0a>0.0</span><span class=\"tick-label\" style=\"left:75%;\" data-v-1fb2cb0a>+0.5</span><span class=\"tick-label\" style=\"left:100%;\" data-v-1fb2cb0a>+1.0<br data-v-1fb2cb0a><span class=\"tick-sublabel\" data-v-1fb2cb0a>(Humane)</span></span></div>", 1))
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"chart-legend\" data-v-1fb2cb0a><span class=\"legend-item\" data-v-1fb2cb0a><span class=\"legend-line legend-green\" data-v-1fb2cb0a></span> Good Persona </span><span class=\"legend-item\" data-v-1fb2cb0a><span class=\"legend-dot\" data-v-1fb2cb0a></span> Baseline </span><span class=\"legend-item\" data-v-1fb2cb0a><span class=\"legend-line legend-red\" data-v-1fb2cb0a></span> Bad Persona </span></div>", 1))
  ]))
}